<template>
  <global-footer class="footer custom-render">
    <!-- <template v-slot:links>
      <div>
        Copyright© 2025 福建华软智通科技有限公司 ALL Rights Reserved
        <a href="https://beian.miit.gov.cn" target="_blank">闽ICP备2024062617号-1</a>
      </div>
    </template>
    <template v-slot:copyright> </template> -->
  </global-footer>
</template>

<script>
import { GlobalFooter } from '@ant-design-vue/pro-layout'

export default {
  name: 'ProGlobalFooter',
  components: {
    GlobalFooter,
  },
}
</script>
